module.exports = __webpack_public_path__ + "static/logo-e77db5a17457bd87cac1dcc63aca1079.jpg";